import uiUploadImage from './upload-image'
import uiUploadLogo from './upload-logo'

export { uiUploadImage, uiUploadLogo }
